import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/finance/profit')({
  component: () => <PageStub title="Profit First" description="Profit allocation and management" />,
});
